import { DateTime, Interval } from 'luxon';

import { Period, DateRange } from '../types';

export const getIntervalForPeriod = (period: Period, timezone: string, dateRange?: DateRange) => {
  const now = DateTime.now().setZone(timezone);
  switch (period) {
    case 'yesterday': {
      const start = now.minus({ days: 1 }).startOf('day');
      const end = start.plus({ days: 1 });
      return Interval.fromDateTimes(start, end);
    }
    case 'this-week': {
      const start = now.startOf('week');
      const end = start.plus({ weeks: 1 });
      return Interval.fromDateTimes(start, end);
    }
    case 'last-week': {
      const start = now.minus({ weeks: 1 }).startOf('week');
      const end = start.plus({ weeks: 1 });
      return Interval.fromDateTimes(start, end);
    }
    case 'this-month': {
      const start = now.startOf('month');
      const end = start.plus({ months: 1 });
      return Interval.fromDateTimes(start, end);
    }
    case 'last-month': {
      const start = now.minus({ months: 1 }).startOf('month');
      const end = start.plus({ months: 1 });
      return Interval.fromDateTimes(start, end);
    }
    case 'custom': {
      if (!dateRange) {
        throw new Error('dateRange not defined for custom period');
      }
      const { from, to } = dateRange;
      const start = DateTime.fromObject(
        { year: from.getFullYear(), month: from.getMonth() + 1, day: from.getDate() },
        { zone: timezone },
      );
      const end = DateTime.fromObject(
        { year: to.getFullYear(), month: to.getMonth() + 1, day: to.getDate() },
        { zone: timezone },
      ).plus({ days: 1 });
      return Interval.fromDateTimes(start, end);
    }
  }
};
